module.exports = __webpack_public_path__ + "0af5d249/img/share-icon.0f8a11b4.svg";